import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ThietLapLuongService from "services/salary/ThietLapLuongService.js";
import Utils from "utils";

export const thietlapluongGetAll = createAsyncThunk(
  "thietlapluong/thietlapluongGetAll",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ThietLapLuongService.getAll(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const thietLapPhuCapGiamTruGetAll = createAsyncThunk(
  "thietlapluong/thietLapPhuCapGiamTruGetAll",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ThietLapLuongService.thietlapphucapgiamtruGetAll(
        data
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const createThietLapPhuCapGiamTru = createAsyncThunk(
  "thietlapluong/createThietLapPhuCapGiamTru",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await ThietLapLuongService.createThietLapPhuCapGiamTru(
        data
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const updateThietLapPhuCapGiamTru = createAsyncThunk(
  "thietlapluong/updateThietLapPhuCapGiamTru",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const response = await ThietLapLuongService.updateThietLapPhuCapGiamTru(
        data
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const deleteThietLapPhuCapGiamTru = createAsyncThunk(
  "thietlapluong/deleteThietLapPhuCapGiamTru",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response = await ThietLapLuongService.deleteThietLapPhuCapGiamTru(
        id
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const GetDanhSachKhoanCapBac = createAsyncThunk(
  "thietlapluong/getDanhSachKhoanCapBac",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await ThietLapLuongService.getDanhSachKhoanCapBac(
        payload
      );
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetDanhMucKhoan = createAsyncThunk(
  "thietlapluong/GetDanhMucKhoan",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ThietLapLuongService.getDmKhoan();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const bangLuongImportKhoanCapBacSync = createAsyncThunk(
  "quanlyluong/bangLuongImportKhoanCapBacSync",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await ThietLapLuongService.importKhoanCapBac(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateBangLuongImportKhoanCapBacSync = createAsyncThunk(
  "quanlyluong/updateBangLuongImportKhoanCapBacSync",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await ThietLapLuongService.updateImportBangLuongKhoan(
        payload
      );
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetAllDanhMucThanhQuaBangLuongApi = createAsyncThunk(
  "quanlyluong/GetAllDanhMucThanhQuaBangLuongApi",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ThietLapLuongService.getAllThanhQuaBangLuong();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpSertThanhQuaBangLuongApi = createAsyncThunk(
  "quanlyluong/UpSertThanhQuaBangLuongApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await ThietLapLuongService.upSertThanhQuaBangLuong(
        payload
      );
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetAllDanhMucPhuCapKhacApi = createAsyncThunk(
  "quanlyluong/GetAllDanhMucPhuCapKhacApi",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ThietLapLuongService.getAllPhuCapKhac();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpSertPhuCapKhacLuongApi = createAsyncThunk(
  "quanlyluong/UpSertPhuCapKhacLuongApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await ThietLapLuongService.upSertPhuCapKhac(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  thietlapluong: {},
  thietlapphucapgiamtruList: [],
  khoanData: {},
  thanhQuaData: [],
  phuCapData: [],
};

export const thietlapluongSlice = createSlice({
  name: "thietlapluong",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setThietLapThanhQua: (state, action) => {
      state.thanhQuaData = action.payload;
    },
    setThietLapPhuCapKhac: (state, action) => {
      state.phuCapData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(thietlapluongGetAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(thietlapluongGetAll.fulfilled, (state, action) => {
        state.loading = false;
        state.thietlapluong = action.payload;
      })
      .addCase(thietlapluongGetAll.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(thietLapPhuCapGiamTruGetAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(thietLapPhuCapGiamTruGetAll.fulfilled, (state, action) => {
        state.loading = false;
        state.thietlapphucapgiamtruList = action.payload;
      })
      .addCase(thietLapPhuCapGiamTruGetAll.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetDanhSachKhoanCapBac.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDanhSachKhoanCapBac.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(GetDanhSachKhoanCapBac.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetDanhMucKhoan.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDanhMucKhoan.fulfilled, (state, action) => {
        state.loading = false;
        state.khoanData = action.payload;
      })
      .addCase(GetDanhMucKhoan.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetAllDanhMucThanhQuaBangLuongApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDanhMucThanhQuaBangLuongApi.fulfilled, (state, action) => {
        state.loading = false;
        state.thanhQuaData = action.payload.map((element) => ({
          ...element,
          ngayApDung: Utils.convertMomentToDate(element.ngayApDung),
        }));
      })
      .addCase(GetAllDanhMucThanhQuaBangLuongApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertThanhQuaBangLuongApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertThanhQuaBangLuongApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertThanhQuaBangLuongApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetAllDanhMucPhuCapKhacApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDanhMucPhuCapKhacApi.fulfilled, (state, action) => {
        state.loading = false;
        state.phuCapData = action.payload;
      })
      .addCase(GetAllDanhMucPhuCapKhacApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertPhuCapKhacLuongApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertPhuCapKhacLuongApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertPhuCapKhacLuongApi.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setThietLapThanhQua, setThietLapPhuCapKhac } =
  thietlapluongSlice.actions;

export default thietlapluongSlice.reducer;
